import { ASSET_TYPES } from "../../../enums/assetTypes.enum";
import { isNotNullOrUndefined, transformManufacturerName } from "../../../shared/utils/utils";
import { Position } from "../../shared/position";
import {
  FaultRef,
  LocationRef,
  CustomerRef,
  TenantRef,
  AtedBy,
  Timestamp,
  Reference,
  GateSystemRef,
} from "../../shared/refs";
import { Parents } from "./botevoAsset";
type NonUndefined<T> = {
  [P in keyof T]: Exclude<T[P], undefined>;
};
interface BuildingRef {
  id?: string;
  label?: string;
  buildingFloorMapUrl?: string;
}
export interface GateSystemDTO {
  id?: string | null;
  label: string;
  assetType?: string | null;
  fault?: FaultRef;
  repairStatus?: string | null;
  coreId?: string | null;
  core?: boolean | null;
  severity?: string | null;
  personalDoor?: boolean | null;
  gateHistoryCycle?: number | null;
  activeDate?: number | null;
  tempOffset?: string | null;
  width?: number | null;
  height?: number | null;
  normalOperationThreshold?: number | null;
  hasGuard?: boolean | null;
  status?: string | null;
  loadingBridge?: string | null;
  quickupGate?: string | null;
  isSluiceGate?: boolean | null;
  hasButler?: boolean | null;
  emailEnergyLoss?: boolean | null;
  notes?: string | null;
  position?: Position;
  gateType?: Reference | null;
  gateManufacturer?: string | null;
  gateMake?: string | null;
  brand?: string | null;
  controlManufacturer?: Reference | null;
  controlModel?: Reference | null;
  building?: BuildingRef;
  location?: LocationRef;
  customer?: CustomerRef;
  tenant?: TenantRef;
  gateSystem?: GateSystemRef;
  gateNumber?: string | null;
  retailerNumber?: string | null;
  expectedEnergyLossPerDay?: number | null;
  expectedEnergyLossPerYear?: number | null;
  timestamp?: Timestamp;
  createdBy?: AtedBy | null;
  updatedBy?: AtedBy | null;
}

export class GateSystem {
  id?: string;
  assetType: string;
  label: string;
  status?: string;
  coreId?: string;
  personalDoor?: boolean;
  gateHistoryCycle?: number;
  activeDate?: number;
  tempOffset?: number;
  expectedEnergyLossPerDay?: number;
  expectedEnergyLossPerYear?: number;
  width?: number;
  height?: number;
  normalOperationThreshold?: number | null;
  hasButler?: boolean;
  hasGuard?: boolean;
  loadingBridge?: string;
  quickupGate?: string;
  isSluiceGate?: boolean;
  emailEnergyLoss?: boolean;
  location?: Reference;
  building?: BuildingRef;
  customer?: Reference;
  gateType?: Reference;
  gateNumber?: string;
  gateSystem?: GateSystemRef;
  retailerNumber?: string;
  gateManufacturer?: string;
  gateMake?: string;
  controlManufacturer?: Reference;
  controlModel?: Reference;
  buildingFloorMapUrl?: string;
  position?: Position;
  severity?: string;
  core?: boolean;

  constructor(gateSystem: GateSystemDTO) {
    if (gateSystem.id) this.id = gateSystem.id;
    this.assetType = ASSET_TYPES.GATE_SYSTEM;
    this.label = gateSystem.label;
    if (gateSystem.status) this.status = gateSystem.status;
    if (gateSystem.severity) this.severity = gateSystem.severity;
    if (gateSystem.coreId) this.coreId = gateSystem.coreId;
    if (isNotNullOrUndefined(gateSystem.expectedEnergyLossPerYear)) {
      this.expectedEnergyLossPerDay =
        gateSystem.expectedEnergyLossPerYear !== undefined ? gateSystem.expectedEnergyLossPerYear / 365 : undefined;
      this.expectedEnergyLossPerYear = gateSystem.expectedEnergyLossPerYear;
    }
    if (isNotNullOrUndefined(gateSystem.personalDoor)) this.personalDoor = gateSystem.personalDoor;
    if (isNotNullOrUndefined(gateSystem.gateHistoryCycle)) this.gateHistoryCycle = gateSystem.gateHistoryCycle;
    if (isNotNullOrUndefined(gateSystem.activeDate)) this.activeDate = gateSystem.activeDate;
    if (isNotNullOrUndefined(gateSystem.tempOffset)) this.tempOffset = Number(gateSystem.tempOffset);
    if (isNotNullOrUndefined(gateSystem.width)) this.width = gateSystem.width;
    if (isNotNullOrUndefined(gateSystem.height)) this.height = gateSystem.height;
    this.normalOperationThreshold = gateSystem.normalOperationThreshold || 0;
    if (isNotNullOrUndefined(gateSystem.hasGuard)) this.hasGuard = gateSystem.hasGuard;
    if (isNotNullOrUndefined(gateSystem.hasButler)) this.hasButler = gateSystem.hasButler;
    if (isNotNullOrUndefined(gateSystem.loadingBridge)) this.loadingBridge = gateSystem.loadingBridge;
    if (isNotNullOrUndefined(gateSystem.quickupGate)) this.quickupGate = gateSystem.quickupGate;
    if (isNotNullOrUndefined(gateSystem.isSluiceGate)) this.isSluiceGate = gateSystem.isSluiceGate;
    if (isNotNullOrUndefined(gateSystem.emailEnergyLoss)) this.emailEnergyLoss = gateSystem.emailEnergyLoss;
    if (gateSystem.location) this.location = gateSystem.location;
    if (gateSystem.building) this.building = gateSystem.building;
    if (gateSystem.customer) this.customer = gateSystem.customer;
    if (gateSystem.gateType) this.gateType = gateSystem.gateType;
    if (gateSystem.gateManufacturer) this.gateManufacturer = gateSystem.gateManufacturer;
    if (gateSystem.gateNumber) this.gateNumber = gateSystem.gateNumber;
    if (gateSystem.retailerNumber) this.retailerNumber = gateSystem.retailerNumber;
    if (gateSystem.gateMake) this.gateMake = gateSystem.gateMake;
    if (isNotNullOrUndefined(gateSystem.core)) this.core = gateSystem.core;
    if (gateSystem.gateSystem) this.gateSystem = gateSystem.gateSystem;
    if (gateSystem.controlManufacturer) {
      this.controlManufacturer = {
        label: transformManufacturerName(gateSystem.controlManufacturer?.label),
        id: gateSystem.controlManufacturer.id,
      };
    }
    if (gateSystem.controlModel) this.controlModel = gateSystem.controlModel;
    if (gateSystem.position) this.position = gateSystem.position;
  }
  public set parents(parents: Parents) {
    this.location = parents.location;
    this.customer = parents.customer;
  }
  public get values(): Partial<NonUndefined<GateSystemDTO>> {
    const entries = Object.entries(this)
      .filter(([value]) => value !== undefined && value !== null)
      .map(([key, value]) => [key, value as Exclude<any, undefined>]);

    const values = Object.fromEntries(entries);
    if (values.id) {
      delete values.id;
    }

    if (values.building?.buildingFloorMapUrl) {
      delete values.building.buildingFloorMapUrl;
    }

    if (values.gateSystem) {
      delete values.gateSystem;
    }
    if (values.normalOperationThreshold === 0) {
      values.normalOperationThreshold = null;
    }
    if (values.status) {
      delete values.status;
    }

    if (values.buildingFloorMapUrl) {
      delete values.buildingFloorMapUrl;
    }

    if (values.assetType) {
      delete values.assetType;
    }
    if (values.severity) {
      delete values.severity;
    }
    if (!values.core) {
      delete values.controlManufacturer;
      delete values.controlModel;
    }

    if (!values.position?.latitude && !values.position?.longitude) {
      delete values.position;
    }

    return values;
  }

  public get directParentId() {
    return this.building?.id;
  }

  public set properties(gateSystem: GateSystemDTO) {
    this.label = gateSystem.label;
    // if(gateSystem.status) this.status = gateSystem.status;
    if (gateSystem.coreId) this.coreId = gateSystem.coreId;
    if (isNotNullOrUndefined(gateSystem.personalDoor)) this.personalDoor = gateSystem.personalDoor;
    if (isNotNullOrUndefined(gateSystem.gateHistoryCycle)) this.gateHistoryCycle = gateSystem.gateHistoryCycle;
    if (isNotNullOrUndefined(gateSystem.activeDate)) this.activeDate = gateSystem.activeDate;
    if (isNotNullOrUndefined(gateSystem.tempOffset)) this.tempOffset = Number(gateSystem.tempOffset);
    if (isNotNullOrUndefined(gateSystem.width)) this.width = gateSystem.width;
    if (isNotNullOrUndefined(gateSystem.height)) this.height = gateSystem.height;
    if (isNotNullOrUndefined(gateSystem.normalOperationThreshold))
      this.normalOperationThreshold = gateSystem.normalOperationThreshold;
    // this.expectedEnergyLossPerDay = gateSystem.expectedEnergyLossPerDay;
    if (isNotNullOrUndefined(gateSystem.expectedEnergyLossPerYear))
      this.expectedEnergyLossPerYear = gateSystem.expectedEnergyLossPerYear;
    if (isNotNullOrUndefined(gateSystem.hasButler)) this.hasButler = gateSystem.hasButler;
    if (isNotNullOrUndefined(gateSystem.hasGuard)) this.hasGuard = gateSystem.hasGuard;
    if (isNotNullOrUndefined(gateSystem.loadingBridge)) this.loadingBridge = gateSystem.loadingBridge;
    if (isNotNullOrUndefined(gateSystem.quickupGate)) this.quickupGate = gateSystem.quickupGate;
    if (gateSystem.gateNumber) this.gateNumber = gateSystem.gateNumber;
    if (gateSystem.retailerNumber) this.retailerNumber = gateSystem.retailerNumber;
    if (isNotNullOrUndefined(gateSystem.isSluiceGate)) this.isSluiceGate = gateSystem.isSluiceGate;
    if (isNotNullOrUndefined(gateSystem.emailEnergyLoss)) this.emailEnergyLoss = gateSystem.emailEnergyLoss;
    if (isNotNullOrUndefined(gateSystem.core)) this.core = gateSystem.core;
    if (gateSystem.location) {
      this.location = gateSystem.location;
    }
    if (gateSystem.building && gateSystem.building) {
      this.building = gateSystem.building;
    }
    if (this.customer && gateSystem.customer) {
      this.customer = gateSystem.customer;
    }
    if (gateSystem.gateType) this.gateType = gateSystem.gateType;
    if (gateSystem.gateManufacturer) this.gateManufacturer = gateSystem.gateManufacturer;
    if (gateSystem.gateMake) this.gateMake = gateSystem.gateMake;
    this.position = gateSystem.position;
    if (gateSystem.controlManufacturer) {
      this.controlManufacturer = {
        label: transformManufacturerName(gateSystem.controlManufacturer?.label),
        id: gateSystem.controlManufacturer.id,
      };
    }
    if (gateSystem.controlModel) {
      this.controlModel = {
        label: gateSystem.controlModel?.label,
        id: gateSystem.controlModel.id,
      };
    }
  }
}
